import axios from 'axios';
import appConfig, { vpmServerUrl } from '../siteConfigs/appConfig';

export { vpmServerUrl };

/** All API calls use httpOnly SESSION cookie (credentials). */
const api = axios.create({
  baseURL: appConfig.api.baseUrl,
  timeout: appConfig.api.timeoutMs,
  headers: { Locale: appConfig.api.defaultLocaleHeader },
  withCredentials: true,
});

/** @deprecated Session is cookie-based; no Authorization header. */
export function setAuthToken() {
  delete api.defaults.headers.common.Authorization;
}

export default api;
